/*
 * Labels for domain values (src/i18n/DomainLabels.js, src/i18n/Jurisdictions.js) and
 * the text the domain JS builds itself (Inspection.tripDisplay, Schedule.nameDisplay,
 * the connection progress messages that used to come from MC.Status).
 * Owned by wave 1 and FROZEN during wave 2.
 */
export default {
  // Trip type (Inspection.tripDisplay). Web English keeps its hyphen.
  inspection_pre_trip: { en: 'Pre-Trip', fr: 'Avant le départ', es: 'Previa al viaje' },
  inspection_post_trip: { en: 'Post-Trip', fr: 'Après le trajet', es: 'Posterior al viaje' },
  inspection_general: { en: 'General', fr: 'Général', es: 'General' },

  // Schedule.nameDisplay
  inspectionDeclaration: {
    en: 'I declare that this vehicle has been inspected in accordance with {0}',
    fr: 'Je déclare que ce véhicule a été inspecté conformément à {0}',
    es: 'Declaro que este vehículo ha sido inspeccionado de acuerdo con {0}',
  },

  // Defect type codes (none / minor / major)
  dailylog_defect_none: { en: 'No Defects', fr: 'Aucune défectuosité', es: 'Sin defectos' },
  dailylog_defect_minor: { en: 'Minor', fr: 'Mineure', es: 'Menor' },
  dailylog_defect_major: { en: 'Major', fr: 'Majeure', es: 'Mayor' },
  labelGood: { en: 'Good', fr: 'Bon', es: 'Bueno' },

  // Connection progress (was MC.Status / MC.Company.Status)
  domain_status_loading: { en: 'Loading please wait...', fr: 'Chargement, veuillez patienter...', es: 'Cargando, espere...' },
  domain_status_done: { en: 'Done!', fr: 'Terminé!', es: '¡Listo!' },
  domain_status_reconnecting: { en: 'Reconnecting to ReadyChek...', fr: 'Reconnexion à ReadyChek...', es: 'Reconectando con ReadyChek...' },
  domain_status_creating_session: { en: 'Creating session...', fr: 'Création de la session...', es: 'Creando la sesión...' },
  domain_status_finding_you: { en: 'Finding you...', fr: 'Recherche de votre profil...', es: 'Buscando su perfil...' },
  domain_status_finding_schedules: { en: 'Finding Schedules...', fr: "Recherche des annexes d'inspection...", es: 'Buscando programas de inspección...' },
  domain_status_finding_inspections: { en: 'Finding Inspections...', fr: 'Recherche des inspections...', es: 'Buscando inspecciones...' },
  domain_status_finding_hours: { en: 'Finding Hours of Service...', fr: 'Recherche des heures de service...', es: 'Buscando horas de servicio...' },
  domain_status_storing_data: { en: 'Storing data...', fr: 'Enregistrement des données...', es: 'Guardando los datos...' },
  domain_status_loading_company: {
    en: 'Loading company details please wait...',
    fr: "Chargement des détails de l'entreprise, veuillez patienter...",
    es: 'Cargando los datos de la empresa, espere...',
  },

  // Vehicle category (ContentUtils.CATEGORIES, code = '@rid')
  vehicle_pickup_label: { en: 'Truck', fr: 'Camion', es: 'Camión' },
  vehicle_trailer_label: { en: 'Trailer', fr: 'Remorque', es: 'Remolque' },
  domain_category_bucket_truck: { en: 'Bucket Truck', fr: 'Camion-nacelle', es: 'Camión con canasta' },
  vehicle_bus_label: { en: 'Bus', fr: 'Autobus', es: 'Autobús' },
  domain_category_motor_coach: { en: 'Bus (Motor Coach)', fr: 'Autocar', es: 'Autocar' },
  vehicle_school_bus_label: { en: 'Bus (School)', fr: 'Autobus (scolaire)', es: 'Autobús (escolar)' },
  vehicle_car_label: { en: 'Car', fr: 'Auto', es: 'Automóvil' },
  domain_category_cube_van: { en: 'Cube Van', fr: 'Camion cube', es: 'Furgón de caja' },
  domain_category_drill_truck: { en: 'Drill Truck', fr: 'Camion de forage', es: 'Camión perforador' },
  domain_category_dump_truck: { en: 'Dump Truck', fr: 'Camion à benne', es: 'Camión de volteo' },
  domain_category_highway_tractor: { en: 'Highway Tractor', fr: 'Tracteur routier', es: 'Tractocamión' },
  domain_category_limo: { en: 'Limo', fr: 'Limousine', es: 'Limusina' },
  domain_category_straight_truck: { en: 'Straight Truck', fr: 'Camion porteur', es: 'Camión rígido' },
  vehicle_school_purpose_vehicle_label: { en: 'School Purpose Vehicle', fr: 'Véhicule à usage scolaire', es: 'Vehículo de uso escolar' },
  domain_category_suv: { en: 'SUV', fr: 'VUS', es: 'SUV' },
  domain_category_tow_truck: { en: 'Tow Truck', fr: 'Dépanneuse', es: 'Grúa' },
  domain_category_vacuum_truck: { en: 'Vacuum Truck', fr: 'Camion aspirateur', es: 'Camión de vacío' },
  vehicle_van_label: { en: 'Van', fr: 'Fourgon', es: 'Furgoneta' },
  domain_unknown: { en: 'Unknown', fr: 'Inconnu', es: 'Desconocido' },

  // Brake type (ContentUtils.BRAKE_TYPES and Vehicle.brakeTypeDisplay)
  vehicle_air_brake_label: { en: 'Air', fr: 'Air', es: 'Aire' },
  vehicle_electric_brake_label: { en: 'Electric', fr: 'Électriques', es: 'Eléctricos' },
  vehicle_hydraulic_brake_label: { en: 'Hydraulic', fr: 'Hydrauliques', es: 'Hidráulicos' },
  vehicle_none_brake_label: { en: 'None', fr: 'Aucun', es: 'Ninguno' },
  domain_brakes_air: { en: 'Air Brakes', fr: 'Freins à air', es: 'Frenos de aire' },
  domain_brakes_electric: { en: 'Electric Brakes', fr: 'Freins électriques', es: 'Frenos eléctricos' },
  domain_brakes_hydraulic: { en: 'Hydraulic Brakes', fr: 'Freins hydrauliques', es: 'Frenos hidráulicos' },

  // Odometer unit (ContentUtils.UNITS)
  veh_kilometers: { en: 'Kilometers', fr: 'Kilomètres', es: 'Kilómetros' },
  veh_miles: { en: 'Miles', fr: 'Milles', es: 'Millas' },

  // Country (ContentUtils.COUNTRYS)
  domain_country_canada: { en: 'Canada', fr: 'Canada', es: 'Canadá' },
  domain_country_us: { en: 'United States', fr: 'États-Unis', es: 'Estados Unidos' },

  // Roles (ContentUtils.ROLES / ROLES2, code = '@rid' or role key)
  domain_role_driver: { en: 'Commercial Driver', fr: 'Conducteur commercial', es: 'Conductor comercial' },
  domain_role_nc_driver: { en: 'Non Commercial Driver', fr: 'Conducteur non commercial', es: 'Conductor no comercial' },
  domain_role_manager: { en: 'Manager', fr: 'Gestionnaire', es: 'Gerente' },
  domain_role_owner: { en: 'Owner', fr: 'Propriétaire', es: 'Propietario' },
  labelMechanic: { en: 'Mechanic', fr: 'Mécanicien', es: 'Mecánico' },
  domain_role_driver_details: {
    en: 'This driver can perform inspections. If you use hours of service(HOS), this driver will be required to start an HOS record before performing an inspection.',
    fr: "Ce conducteur peut faire des inspections. Si vous utilisez les heures de service, il devra commencer une fiche d'heures de service avant de faire une inspection.",
    es: 'Este conductor puede hacer inspecciones. Si usa horas de servicio (HOS), deberá iniciar un registro de HOS antes de hacer una inspección.',
  },
  domain_role_nc_driver_details: {
    en: 'This driver can perform inspections. if you use hours of service(HOS), this driver will NOT be required to start an HOS record before performing an inspection',
    fr: "Ce conducteur peut faire des inspections. Si vous utilisez les heures de service, il ne sera PAS tenu de commencer une fiche d'heures de service avant de faire une inspection",
    es: 'Este conductor puede hacer inspecciones. Si usa horas de servicio (HOS), NO tendrá que iniciar un registro de HOS antes de hacer una inspección',
  },
  domain_role_manager_details: {
    en: 'A manager can perform inspections and use this portal. If you use hours of service (HOS) this manager has the option to use it, but is not required.',
    fr: "Un gestionnaire peut faire des inspections et utiliser ce portail. Si vous utilisez les heures de service, il peut s'en servir, sans y être obligé.",
    es: 'Un gerente puede hacer inspecciones y usar este portal. Si usa horas de servicio (HOS), puede usarlas, pero no está obligado.',
  },
  domain_role_owner_details: {
    en: 'An owner can perform inspections and use this protal. If you use hours of service (HOS) this owner has the option to use it, but is not required.',
    fr: "Un propriétaire peut faire des inspections et utiliser ce portail. Si vous utilisez les heures de service, il peut s'en servir, sans y être obligé.",
    es: 'Un propietario puede hacer inspecciones y usar este portal. Si usa horas de servicio (HOS), puede usarlas, pero no está obligado.',
  },
  domain_role_mechanic_details: {
    en: 'A mechanic can perform use the portal to update vehicles, equipment, checklists and record repairs. If you use hours of service(HOS), a mechanic will be required to start an HOS record before performing an inspection.',
    fr: "Un mécanicien peut utiliser le portail pour mettre à jour les véhicules, l'équipement et les listes de vérification, et pour consigner les réparations. Si vous utilisez les heures de service, il devra commencer une fiche d'heures de service avant de faire une inspection.",
    es: 'Un mecánico puede usar el portal para actualizar vehículos, equipos y listas de verificación, y registrar reparaciones. Si usa horas de servicio (HOS), deberá iniciar un registro de HOS antes de hacer una inspección.',
  },

  // Record state (ContentUtils.STATES / STATUS)
  domain_state_locked: { en: 'Locked', fr: 'Verrouillé', es: 'Bloqueado' },
  domain_state_deleted: { en: 'Deleted', fr: 'Supprimé', es: 'Eliminado' },
  domain_state_inactive: { en: 'Inactive', fr: 'Inactif', es: 'Inactivo' },
  domain_state_active: { en: 'Active', fr: 'Actif', es: 'Activo' },
  domain_state_all: { en: 'All', fr: 'Tous', es: 'Todos' },

  // Checklist question types and answer categories
  domain_item_type_text: { en: 'Text', fr: 'Texte', es: 'Texto' },
  domain_item_type_number: { en: 'Number', fr: 'Nombre', es: 'Número' },
  domain_item_type_list: { en: 'List', fr: 'Liste', es: 'Lista' },
  domain_item_type_bool: { en: 'Yes/No', fr: 'Oui/Non', es: 'Sí/No' },
  domain_item_type_text_details: { en: 'Allows the driver to enter in text', fr: 'Permet au conducteur de saisir du texte', es: 'Permite al conductor escribir texto' },
  domain_item_type_number_details: { en: 'Allows the driver to enter in a number', fr: 'Permet au conducteur de saisir un nombre', es: 'Permite al conductor escribir un número' },
  domain_item_type_list_details: { en: 'Allows the driver to pick from a list of possible answers', fr: 'Permet au conducteur de choisir dans une liste de réponses possibles', es: 'Permite al conductor elegir de una lista de respuestas posibles' },
  domain_item_type_bool_details: { en: 'Allows the driver to pick from one of two options', fr: "Permet au conducteur de choisir l'une de deux options", es: 'Permite al conductor elegir una de dos opciones' },
  domain_option_good_details: { en: 'This is not a problem', fr: "Ce n'est pas un problème", es: 'Esto no es un problema' },
  domain_option_minor_details: {
    en: 'This problem is minor, email sent to safety manager',
    fr: 'Ce problème est mineur; un courriel est envoyé au responsable de la sécurité',
    es: 'Este problema es menor; se envía un correo al responsable de seguridad',
  },
  domain_option_major_details: {
    en: 'This problem is major, email sent to safety manager',
    fr: 'Ce problème est majeur; un courriel est envoyé au responsable de la sécurité',
    es: 'Este problema es mayor; se envía un correo al responsable de seguridad',
  },

  // Billing (ContentUtils.PAYMENT_FREQUENCYS / PAYMENT_METHODS)
  domain_freq_monthly: { en: 'Monthly', fr: 'Mensuel', es: 'Mensual' },
  domain_freq_quarterly: { en: 'Quarterly', fr: 'Trimestriel', es: 'Trimestral' },
  domain_freq_semi_annually: { en: 'Semi-Annually', fr: 'Semestriel', es: 'Semestral' },
  domain_freq_annually: { en: 'Annually', fr: 'Annuel', es: 'Anual' },
  domain_pay_credit_card: { en: 'Credit Card', fr: 'Carte de crédit', es: 'Tarjeta de crédito' },
  domain_pay_wire_transfer: { en: 'Wire Transfer', fr: 'Virement bancaire', es: 'Transferencia bancaria' },
  domain_pay_etransfer: { en: 'eTransfer', fr: 'Virement Interac', es: 'Transferencia electrónica' },
  domain_pay_cheque: { en: 'Cheque', fr: 'Chèque', es: 'Cheque' },

  // Paging (ContentUtils.PAGE_SIZES / PAGE_INDEXES)
  domain_page_size: { en: 'Page Size {0}', fr: 'Taille de page {0}', es: 'Tamaño de página {0}' },
  domain_page_number: { en: 'Page {0}', fr: 'Page {0}', es: 'Página {0}' },

  // Fleet size (ContentUtils.FLEET_SIZE)
  domain_fleet_range: { en: '{0} to {1}', fr: '{0} à {1}', es: '{0} a {1}' },

  // How did you hear about us (ContentUtils.SOCIALS / ADS); brand names are not translated
  domain_social_web_search: { en: 'Web Search', fr: 'Recherche Web', es: 'Búsqueda web' },
  domain_social_web_ad: { en: 'Web Advertisement', fr: 'Publicité Web', es: 'Anuncio web' },
  domain_social_friend: { en: 'A friend', fr: 'Un ami', es: 'Un amigo' },
  domain_social_other: { en: 'Other', fr: 'Autre', es: 'Otro' },
  domain_social_landscape_ontario: { en: 'Landscape Ontario Event', fr: 'Événement Landscape Ontario', es: 'Evento de Landscape Ontario' },

  // Jurisdictions (Jurisdictions.js). Codes are the stored English names.
  vehicle_ontario_label: { en: 'Ontario', fr: 'Ontario', es: 'Ontario' },
  vehicle_alberta_label: { en: 'Alberta', fr: 'Alberta', es: 'Alberta' },
  vehicle_bc_label: { en: 'British Columbia', fr: 'Colombie-Britannique', es: 'Columbia Británica' },
  vehicle_manitoba_label: { en: 'Manitoba', fr: 'Manitoba', es: 'Manitoba' },
  vehicle_quebec_label: { en: 'Quebec', fr: 'Québec', es: 'Quebec' },
  vehicle_sask_label: { en: 'Saskatchewan', fr: 'Saskatchewan', es: 'Saskatchewan' },
  vehicle_new_brunswick_label: { en: 'New Brunswick', fr: 'Nouveau-Brunswick', es: 'Nuevo Brunswick' },
  vehicle_newfoundland_label: { en: 'Newfoundland and Labrador', fr: 'Terre-Neuve-et-Labrador', es: 'Terranova y Labrador' },
  vehicle_nova_scotia_label: { en: 'Nova Scotia', fr: 'Nouvelle-Écosse', es: 'Nueva Escocia' },
  // The portal has always shown the stored misspelling; English keeps showing it.
  domain_nunavit_label: { en: 'Nunavit', fr: 'Nunavut', es: 'Nunavut' },
  vehicle_nwt_label: { en: 'NWT', fr: 'T.N.-O.', es: 'Territorios del Noroeste' },
  vehicle_pei_label: { en: 'PEI', fr: 'Î.-P.-É.', es: 'Isla del Príncipe Eduardo' },
  vehicle_yukon_label: { en: 'Yukon', fr: 'Yukon', es: 'Yukón' },
  vehicle_alabama_label: { en: 'Alabama', fr: 'Alabama', es: 'Alabama' },
  vehicle_alaska_label: { en: 'Alaska', fr: 'Alaska', es: 'Alaska' },
  vehicle_arizona_label: { en: 'Arizona', fr: 'Arizona', es: 'Arizona' },
  vehicle_arkansas_label: { en: 'Arkansas', fr: 'Arkansas', es: 'Arkansas' },
  vehicle_california_label: { en: 'California', fr: 'Californie', es: 'California' },
  vehicle_colorado_label: { en: 'Colorado', fr: 'Colorado', es: 'Colorado' },
  vehicle_connecticut_label: { en: 'Connecticut', fr: 'Connecticut', es: 'Connecticut' },
  vehicle_delaware_label: { en: 'Delaware', fr: 'Delaware', es: 'Delaware' },
  vehicle_florida_label: { en: 'Florida', fr: 'Floride', es: 'Florida' },
  vehicle_georgia_label: { en: 'Georgia', fr: 'Géorgie', es: 'Georgia' },
  vehicle_hawaii_label: { en: 'Hawaii', fr: 'Hawaï', es: 'Hawái' },
  vehicle_idaho_label: { en: 'Idaho', fr: 'Idaho', es: 'Idaho' },
  vehicle_illinois_label: { en: 'Illinois', fr: 'Illinois', es: 'Illinois' },
  vehicle_indiana_label: { en: 'Indiana', fr: 'Indiana', es: 'Indiana' },
  vehicle_iowa_label: { en: 'Iowa', fr: 'Iowa', es: 'Iowa' },
  vehicle_kansas_label: { en: 'Kansas', fr: 'Kansas', es: 'Kansas' },
  vehicle_kentucky_label: { en: 'Kentucky', fr: 'Kentucky', es: 'Kentucky' },
  vehicle_louisiana_label: { en: 'Louisiana', fr: 'Louisiane', es: 'Luisiana' },
  vehicle_maine_label: { en: 'Maine', fr: 'Maine', es: 'Maine' },
  vehicle_maryland_label: { en: 'Maryland', fr: 'Maryland', es: 'Maryland' },
  vehicle_massachusetts_label: { en: 'Massachusetts', fr: 'Massachusetts', es: 'Massachusetts' },
  vehicle_michigan_label: { en: 'Michigan', fr: 'Michigan', es: 'Míchigan' },
  vehicle_minnesota_label: { en: 'Minnesota', fr: 'Minnesota', es: 'Minnesota' },
  vehicle_mississippi_label: { en: 'Mississippi', fr: 'Mississippi', es: 'Misisipi' },
  vehicle_missouri_label: { en: 'Missouri', fr: 'Missouri', es: 'Misuri' },
  vehicle_montana_label: { en: 'Montana', fr: 'Montana', es: 'Montana' },
  vehicle_nebraska_label: { en: 'Nebraska', fr: 'Nebraska', es: 'Nebraska' },
  vehicle_nevada_label: { en: 'Nevada', fr: 'Nevada', es: 'Nevada' },
  vehicle_new_hampshire_label: { en: 'New Hampshire', fr: 'New Hampshire', es: 'Nuevo Hampshire' },
  vehicle_new_jersey_label: { en: 'New Jersey', fr: 'New Jersey', es: 'Nueva Jersey' },
  vehicle_new_mexico_label: { en: 'New Mexico', fr: 'Nouveau-Mexique', es: 'Nuevo México' },
  vehicle_new_york_label: { en: 'New York', fr: 'New York', es: 'Nueva York' },
  vehicle_north_carolina_label: { en: 'North Carolina', fr: 'Caroline du Nord', es: 'Carolina del Norte' },
  vehicle_north_dakota_label: { en: 'North Dakota', fr: 'Dakota du Nord', es: 'Dakota del Norte' },
  vehicle_ohio_label: { en: 'Ohio', fr: 'Ohio', es: 'Ohio' },
  vehicle_oklahoma_label: { en: 'Oklahoma', fr: 'Oklahoma', es: 'Oklahoma' },
  vehicle_oregon_label: { en: 'Oregon', fr: 'Oregon', es: 'Oregón' },
  vehicle_pennsylvania_label: { en: 'Pennsylvania', fr: 'Pennsylvanie', es: 'Pensilvania' },
  vehicle_rhode_island_label: { en: 'Rhode Island', fr: 'Rhode Island', es: 'Rhode Island' },
  vehicle_south_carolina_label: { en: 'South Carolina', fr: 'Caroline du Sud', es: 'Carolina del Sur' },
  vehicle_south_dakota_label: { en: 'South Dakota', fr: 'Dakota du Sud', es: 'Dakota del Sur' },
  vehicle_tennessee_label: { en: 'Tennessee', fr: 'Tennessee', es: 'Tennessee' },
  vehicle_texas_label: { en: 'Texas', fr: 'Texas', es: 'Texas' },
  vehicle_utah_label: { en: 'Utah', fr: 'Utah', es: 'Utah' },
  vehicle_vermont_label: { en: 'Vermont', fr: 'Vermont', es: 'Vermont' },
  vehicle_virginia_label: { en: 'Virginia', fr: 'Virginie', es: 'Virginia' },
  vehicle_washington_label: { en: 'Washington', fr: 'Washington', es: 'Washington' },
  vehicle_west_virginia_label: { en: 'West Virginia', fr: 'Virginie-Occidentale', es: 'Virginia Occidental' },
  vehicle_wisconsin_label: { en: 'Wisconsin', fr: 'Wisconsin', es: 'Wisconsin' },
  vehicle_wyoming_label: { en: 'Wyoming', fr: 'Wyoming', es: 'Wyoming' },
  domain_region_mexico: { en: 'Mexico', fr: 'Mexique', es: 'México' },
  domain_region_south_america: { en: 'South America', fr: 'Amérique du Sud', es: 'América del Sur' },
  domain_region_eu: { en: 'European Union', fr: 'Union européenne', es: 'Unión Europea' },
  domain_region_africa: { en: 'Africa', fr: 'Afrique', es: 'África' },
  domain_region_middle_east: { en: 'Middle East', fr: 'Moyen-Orient', es: 'Oriente Medio' },
  domain_region_japan: { en: 'Japan', fr: 'Japon', es: 'Japón' },
  domain_region_australia: { en: 'Australia', fr: 'Australie', es: 'Australia' },
};
